module.exports = __webpack_public_path__ + "media/stylesheets/images/check_@2X-6465b6db7bd553ffa22016d899b5cad3.png";